import { useState } from "react";
import { CalendarIcon } from "lucide-react";
import { format, parseISO, isValid } from "date-fns";
import { fr, nlBE } from "date-fns/locale";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useLanguage } from "@/i18n";

// Sélecteur de date au format belge (jj/mm/aaaa). value/onChange en ISO "YYYY-MM-DD"
export const DateField = ({ value, onChange, testId, placeholder, withTime = false, className = "" }) => {
  const { t, lang } = useLanguage();
  const [open, setOpen] = useState(false);
  const locale = lang === "nl" ? nlBE : fr;

  const datePart = (value || "").slice(0, 10);
  const timePart = withTime ? (value || "").slice(11, 16) : "";
  const parsed = datePart ? parseISO(datePart) : null;
  const label = parsed && isValid(parsed)
    ? `${format(parsed, "dd/MM/yyyy", { locale })}${withTime && timePart ? ` · ${timePart}` : ""}`
    : (placeholder || t("jj/mm/aaaa"));

  const commit = (nextDate, nextTime) => {
    if (!nextDate) return onChange("");
    onChange(withTime ? `${nextDate}T${nextTime || "09:00"}` : nextDate);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className={`inline-flex w-full items-center gap-2 rounded-xl border border-[#E2E7F7] bg-white px-4 py-3 text-left text-sm transition-colors duration-200 hover:border-[#3A5CC8] focus:outline-none focus:ring-2 focus:ring-[#3A5CC8] ${parsed ? "text-[#0F2645]" : "text-[#93A0BC]"} ${className}`}
        >
          <CalendarIcon className="w-4 h-4 text-[#3A5CC8] shrink-0" />
          {label}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-0 bg-white">
        <Calendar
          mode="single"
          locale={locale}
          weekStartsOn={1}
          defaultMonth={parsed && isValid(parsed) ? parsed : undefined}
          selected={parsed && isValid(parsed) ? parsed : undefined}
          onSelect={(d) => {
            if (!d) return;
            commit(format(d, "yyyy-MM-dd"), timePart);
            if (!withTime) setOpen(false);
          }}
        />
        {withTime && (
          <div className="border-t border-[#E2E7F7] p-3">
            <input
              type="time"
              data-testid={testId ? `${testId}-time` : undefined}
              value={timePart}
              onChange={(e) => commit(datePart || format(new Date(), "yyyy-MM-dd"), e.target.value)}
              className="w-full rounded-lg border border-[#E2E7F7] px-3 py-2 text-sm text-[#0F2645] focus:outline-none focus:ring-2 focus:ring-[#3A5CC8]"
            />
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};
